import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { lenisRef } from "@/lib/lenis";
import LanguageGate from "@/components/LanguageGate";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ScrollySteps from "@/components/ScrollySteps";
import Marquee from "@/components/Marquee";
import WorkGrid from "@/components/WorkGrid";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  const [lang, setLang] = useState(null);
  const effectiveLang = lang || "fr";

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <div data-testid="app-root" className="min-h-screen bg-[#0D0809] text-[#F4EFEA] selection:bg-[#B03A52] selection:text-white">
      <div className="grain" aria-hidden="true" />
      <AnimatePresence>{!lang && <LanguageGate onSelect={setLang} />}</AnimatePresence>
      <Navbar lang={effectiveLang} setLang={setLang} />
      <main>
        <Hero lang={effectiveLang} />
        <ScrollySteps lang={effectiveLang} />
        <Marquee lang={effectiveLang} />
        <WorkGrid lang={effectiveLang} />
        <About lang={effectiveLang} />
        <Contact lang={effectiveLang} />
      </main>
      <Footer lang={effectiveLang} />
    </div>
  );
}
